import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import vw from 'styles/utils';

function ListSection(props) {
  const { title, iconImage, articles, more, showType } = props;

  return (
    <Root {...props}>
      <Row borderBottom>
        <Col>
          <Icon src={iconImage} />
          <Title>{title}</Title>
        </Col>
        <ColMore show={more}>
          <ReadMore href={more} target="_blank" rel="noreferrer">閱讀更多</ReadMore>
        </ColMore>
      </Row>
      <List>
        {
          articles.map((article) => (
            <a href={article.url} target="_blank" rel="noreferrer" key={article.title}>
              <Article>
                <ArticleTitle>
                  <ArticleType show={showType}>{article.type}</ArticleType>
                  <ArticleContent>{article.title}</ArticleContent>
                </ArticleTitle>
                <ArticleDate>{article.date}</ArticleDate>
              </Article>
            </a>
          ))
        }
      </List>
    </Root>
  )
}

ListSection.propTypes = {
  title: PropTypes.string,
  iconImage: PropTypes.node,
  articles: PropTypes.array,
  more: PropTypes.string,
  showType: PropTypes.bool
}

ListSection.defaultProps = {
  title: 'title',
  iconImage: 'iconImage',
  articles: []
}

const Root = styled.div`
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: ${props => props.borderBottom && '1px solid #DADADA'};

  ${vw('padding-bottom', 10, 15)}
  ${vw('margin-bottom', 10, 15)}
`;

const Col = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ColMore = styled.div`
  display: ${props => props.show ? 'flex' : 'none'};
  flex-direction: row;
  align-items: center;
`;

const Icon = styled.img`
  width: auto;
  height: auto;

  ${vw('max-width', 10, 15)}
  ${vw('max-height', 10, 15)}
  ${vw('margin-right', 6, 13)}
`;

const Title = styled.h5`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;

  ${vw('font-size', 12, 18)}
  ${vw('line-height', 20, 28)}
`;

const ReadMore = styled.a`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  color: #252525;
  border: 1px solid #DADADA;
  box-sizing: border-box;
  background: none;
  transition: all 0.25s;

  ${vw('font-size', 10, 12)}
  ${vw('line-height', 16, 22)}
  ${vw('padding-top', 2, 1.5)}
  ${vw('padding-bottom', 2, 1.5)}
  ${vw('padding-left', 10, 15.5)}
  ${vw('padding-right', 10, 15.5)}

  &:hover{
    background: #DADADA;
  }
`;

const List = styled.ul`
  margin: 0;
  padding: 0;

  & > a:nth-of-type(2n+1) > li {
    background: rgba(51, 152, 220, 0.15);
  }

  & > a:nth-of-type(2n) > li {
    background: #F5F7F8;
  }
`;

const Article = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  ${vw('padding-top', 3, 6)}
  ${vw('padding-bottom', 3, 6)}
  ${vw('padding-left', 10, 20)}
  ${vw('padding-right', 10, 20)}

  &:hover {
    p, span {
      color: #3398DC;
    }
  }
`;

const ArticleTitle = styled.div`
  width: 78%;
  display: flex;
`;

const ArticleType = styled.p`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  display: ${props => props.show ? 'flex' : 'none'};
  align-items: center;
  color: #FFFFFF;
  background: #26304D;
  
  ${vw('font-size', 12)}
  ${vw('line-height', 15)}
  ${vw('border-radius', 30)}
  ${vw('margin-right', 10)}
`;

const ArticleContent = styled.p`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  color: #252525;
  transition: all 0.25s;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  ${vw('font-size', 12, 16)};
  ${vw('line-height', 24, 32)};
`;

const ArticleDate = styled.span`
  width: 22%;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  text-align: right;
  color: #757575;
  transition: all 0.25s;

  ${vw('font-size', 12)};
  ${vw('line-height', 22)};
`;

export default ListSection
